import { create } from 'zustand';

/**
 * App-wide blocking states raised by the API client: an outdated build (426) and an outstanding
 * legal acceptance (403 legal_acceptance_required). The shell renders the blocking screen; nothing
 * else needs to handle them.
 */
interface GateState {
  updateRequired: boolean;
  legalRequired: boolean;
  setUpdateRequired: () => void;
  setLegalRequired: () => void;
  clearLegal: () => void;
}

export const gates = create<GateState>((set) => ({
  updateRequired: false,
  legalRequired: false,
  setUpdateRequired: () => set({ updateRequired: true }),
  setLegalRequired: () => set({ legalRequired: true }),
  clearLegal: () => set({ legalRequired: false }),
}));

export const useGates = gates;
